module.exports = new __parcel__URL__("shop_rare_ng_refill_image.61496d9f.png").toString();